<div style="
    text-align: start;
    margin: 10px 5px;
    background-color: #fff;
    page-break-after: always;" *ngFor="let transItem of item.TransactionItems; let e = index" [dir]="dirc"
  [ngStyle]="{'page-break-after': e != item.TransactionItems.length - 1 ? 'always' : ''}">

  <div style="">

    <div class="row">
      <div class="col-lg-12 " style="text-align: center;">
        <div style="text-align: center;width: 100%;" *ngIf="AccountSetup?.ImagePath">
          <img [src]="AccountSetup?.ImagePath" style="width: 100px;text-align: center;" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 " style="text-align: center;">
        <p class="hed" style="
        margin: 0;
        padding: 0;
        width: 100%;
        text-align: center;
        color: #000;
        font-weight: 600;
        font-size: 16px; ">
          {{ sharedService.Lang == 'ar' ? sharedService.BranchNameAr : sharedService.BranchNameEn }} &nbsp; {{
          printLang }}
        </p>
      </div>
    </div>

    <hr />

    <table style="width: 100%" [dir]="dirc">

      <!-- <tr class="row">
        <td class="col-12 text-start">
          <div style="text-align: center" *ngIf="AccountSetup?.ImagePath">
            <img [src]="AccountSetup?.ImagePath" style="width: 60px" />
          </div>
          <p class="hed" style="
    margin: 0;
    padding: 0;
    text-align: center;
    color: #000;
    font-weight: 600;
    font-size: 16px; ">
            {{ sharedService.BranchNameAr
            }} &nbsp; {{ printLang }}
          </p>
        </td>
      </tr> -->

      <tr class="row">
        <td class="col-6 text-start">
          <p style="
              font-family: initial;
              font-size: 18px;
              margin: 0;
              font-weight: 600;
              color: #000;
            ">
            {{ item.Date | date: "dd/MM/yyyy" }}
          </p>

          <p style="
          font-family: initial;
          font-size: 18px;
          margin: 0;
          font-weight: 600;
          color: #000;
        ">
            {{ item.Date | date: "hh:mm a" }}
          </p>

          <p *ngIf="item.BookingDate" style="
              font-family: initial;
              font-size: 18px;
              margin: 0;
              font-weight: 600;
              color: #000;
            ">
            {{ item.BookingDate | date: "dd/MM/yyyy hh:mm a" }}
          </p>

          <p style="font-size: 14px; font-weight: 600; margin: 5px 0px" *ngIf="
          sharedService.CurrentBranch
            .AllowUseNumberOfPrintsInBills &&
          sharedService.CurrentBranch.AllowShowNumberOfPrintsInBills
        ">
            <span>{{ "PrintNumber:" | translate }}</span>
            {{ (item.ItemsNumberOfPrints ?? 0) + 1 }} .
          </p>

          <p class="hed" *ngIf="item.BookingId"
            style="margin: 5px 0  0 0; padding: 0;color: #430fd4; text-align: center; font-weight: 600; font-size: 16px;">
            {{'ForBookingPayment' | translate }} ( {{'Number' | translate }}
            &nbsp;{{item.BookingId}})
          </p>

        </td>

        <td class="col-6 text-center">


          <p style="
          font-family: initial;
          font-size: 18px;
          margin: 0;
          font-weight: 600;
          color: #000;
        ">
            {{ item.Id }}
          </p>

          <p class="hed" *ngIf="item.TransactionType == 2 ||
          item.TransactionType == 1 " style="
              margin: 0;
              padding: 0;
              text-align: center;
              color: #000;
              font-weight: 600;
              font-size: 16px;
            ">
            <!-- {{'BillNumber' | translate }}&nbsp;-&nbsp; -->{{item.TransactionCodeText}}
          </p>


        </td>

      </tr>
    </table>
    <div>

      <div class="row">
        <div class="col-lg-12 " style="text-align: center;">
          <h2 style="color:#000; font-weight:900;">
            {{ ('PrintItems'|translate) }} <span style="color:#464141; font-weight:900;font-size: 14px;">({{
              ('BillItems'|translate) }})</span>
          </h2>
        </div>
        <div class="col-lg-12 " style="text-align: center;">
          <h4 style=" color:#000; font-weight:900;">
            {{ ('ItemName'|translate) + " - " + getItemName(transItem) }}
          </h4>
        </div>
      </div>

      <hr />

      <!-- [dir]="printLang  == 'ar' ? 'rtl' : 'ltr'" -->
      <table style="width: 100%; text-align: start" [dir]="dirc">
        <tr>
          <td style="
              font-family: initial;
              font-size: 20px;
              font-weight: 500;
              width: 360px;
              color: #000;
            ">
            <p style="font-size: 16px; font-weight: 600; margin: 0px">
              {{ "ClientName" | translate }} :
              {{
              printLang == "ar"
              ? item.client?.NameAr
              : item.client?.NameEn
              }}
            </p>

            <p style="font-size: 16px; font-weight: 600; margin: 0px">
              {{ "UserName" | translate }} :
              {{
              printLang == "ar"
              ? item.employee?.NameAr
              : item.employee?.NameEn
              }}
            </p>
            <p style="font-size: 16px; font-weight: 600; margin: 0px">
              {{ "ItemDateAndTime" | translate }} :
              {{ (transItem.Date | date: "dd/MM/yyyy hh:mm") + " " + ( (transItem.Date | date: "a") | translate)}}
            </p>
          </td>
          <td style="text-align: end">
            <div style="text-align: end" *ngIf="AccountSetup?.QRImagePath">
              <img [src]="AccountSetup?.QRImagePath" alt="" style="width: 80px" />
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div>
      <div *ngIf="item.TrProductServices.length > 0">
        <table border="1" style="
            width: 100%;
            border-collapse: collapse;
            text-align: start !important;
            margin: 15px 0;
            border: 2px solid #000;
          " [dir]="dirc">
          <thead style="text-align: start !important" [dir]="dirc">
            <tr style="text-align: start !important" [dir]="dirc">
              <th style="text-align: start !important; color: #000; padding: 5px">
                {{ "Name" | translate }}
              </th>
              <th style="text-align: start !important; color: #000; padding: 5px">
                {{ "Employee" | translate }}
              </th>
              <th style="text-align: start !important; color: #000; padding: 5px">
                {{ "Quantity" | translate }}
              </th>
              <th *ngIf="sharedService.UserIdentity.IsAdmin ||
                  sharedService.UserIdentity.AllowViewBalances"
                style="text-align: start !important; color: #000; padding: 5px">
                {{ "Price" | translate }}
              </th>
              <!-- <th style="text-align: start !important; color: #000; padding:5px;">{{ 'Commission' | translate }}
              </th> -->
              <th *ngIf="sharedService.UserIdentity.IsAdmin ||
                  sharedService.UserIdentity.AllowViewBalances"
                style="text-align: start !important; color: #000; padding: 5px">
                {{ "Total" | translate }}
              </th>
              <th *ngIf="sharedService?.CurrentBranch?.AllowTracingCommissionInCashSale == true &&
               this.hasNonNullEmployeeTransactionCommission(item)"
                style="text-align: start !important; color: #000; padding: 5px">
                {{ "Commission" | translate }}
              </th>

              <!--  <th *ngIf="sharedService?.CurrentBranch?.AllowUseClientsQueueSystem &&
              sharedService?.CurrentBranch?.AllowShowClientsQueueNumberInPrintEmployees &&
              sharedService?.CurrentBranch?.ClientsQueueSystemType == 2"
                style="text-align: start !important; color: #000; padding: 5px">
                {{ "QueueNumber" | translate }}
              </th> -->

            </tr>
          </thead>
          <tbody>
            <tr style="text-align: start">
              <td style="color: #000; padding: 5px">
                {{ (transItem.Note == "PackageService" ? (('PackageService'|translate) + " - ") : "") +
                (transItem.service
                ? printLang == "ar"
                ? transItem.service.NameAr
                : transItem.service.NameEn
                : transItem.Service
                ? printLang == "ar"
                ? transItem.Service.NameAr
                : transItem.Service.NameEn
                : transItem.product
                ? printLang == "ar"
                ? transItem.product.NameAr
                : transItem.product.NameEn
                : transItem.Package
                ? printLang == "ar"
                ? transItem.Package.NameAr
                : transItem.Package.NameEn
                : transItem.OffersSetting
                ? printLang == "ar"
                ? transItem.OffersSetting.NameAr
                : transItem.OffersSetting.NameEn
                : "")
                }}
                <div *ngIf="AccountSetup?.AllowUseRooms == true">
                  <span *ngFor="
                      let room of transItem.ResourceManagements
                    ">
                    {{ room.ResourceName }} <br />
                    {{ "From" | translate }}:
                    {{ room.StartTime | date: "shortTime" }} ,
                    {{ "To" | translate }}:
                    {{ room.EndTime | date: "shortTime" }}
                  </span>
                </div>
              </td>
              <td style="color: #000; padding: 5px">


                {{ transItem.Employee ? (printLang == "ar" ?
                transItem.Employee?.NameAr :
                transItem.Employee?.NameEn ): ('NotFound'|translate)}}


                {{ transItem?.SecondEmployee ? " - " +
                (printLang == "ar" ?
                transItem.SecondEmployee?.NameAr :
                transItem.SecondEmployee?.NameEn) : "" }}
              </td>
              <td style="color: #000; padding: 5px">
                {{ transItem.Quantity }}
              </td>
              <td *ngIf="sharedService.UserIdentity.IsAdmin ||
                  sharedService.UserIdentity.AllowViewBalances" style="color: #000; padding: 5px">
                <span *ngIf="sharedService?.CurrentBranch?.AllowShowItemsPricesInPrintEmployees">
                  {{ transItem?.OriginalPrice?.toFixed(sharedService.GetFractionRoundCount) }}
                </span>
                <span *ngIf="!sharedService?.CurrentBranch?.AllowShowItemsPricesInPrintEmployees">
                  {{ "NotAllowed" | translate }}
                </span>
              </td>
              <!-- <td style="color: #000; padding:5px;">
                {{TrProductService?.EmployeeTransactionCommission[0]?.CommissionValue }} </td> -->
              <td style="color: #000; padding: 5px">
                <span *ngIf="sharedService.UserIdentity.IsAdmin ||
                  sharedService.UserIdentity.AllowViewBalances">
                  {{ transItem?.Total?.toFixed(sharedService.GetFractionRoundCount) }}
                </span>
                <span *ngIf="!sharedService?.CurrentBranch?.AllowShowItemsPricesInPrintEmployees">
                  {{ "NotAllowed" | translate }}
                </span>
              </td>
              <td *ngIf="AccountSetup?.AllowTracingCommissionInCashSale == true
               && transItem?.EmployeeTransactionCommission != null
               && transItem.EmployeeTransactionCommission?.CommissionValue > 0" style="color: #000; padding: 5px">

                <span *ngIf="transItem.EmployeeTransactionCommission?.OverTimeCommissionId != null">
                  {{ "ServiceFeeOvertime" | translate }}
                </span>
                <span>
                  {{
                  transItem.EmployeeTransactionCommission?.CommissionValue.toFixed(sharedService.GetFractionRoundCount)
                  }}
                </span>
              </td>

              <!--  <td *ngIf="sharedService?.CurrentBranch?.AllowUseClientsQueueSystem &&
              sharedService?.CurrentBranch?.AllowShowClientsQueueNumberInPrintEmployees &&
              sharedService?.CurrentBranch?.ClientsQueueSystemType == 2" style="color: #000; padding: 5px">
                {{ transItem.ClientNumberInQueue }}
              </td> -->
            </tr>

            <tr *ngIf="AccountSetup?.AllowTracingCommissionInCashSale == true
                 && transItem?.EmployeeTransactionCommission != null
                 && transItem?.EmployeeTransactionCommission?.HrCommissionSettingDetailId == null
                 && transItem?.EmployeeTransactionCommission?.TargetCommissionValue != 0
                 && transItem.ItemId === transItem.ItemId">
              <td colspan="6">
                <div style="display: flex; justify-content: space-between">

                  <p style="padding: 0px; margin: 0px; font-size: 12px">
                    {{ "Target" | translate }} :

                    {{ transItem?.EmployeeTransactionCommission?.TargetCommissionValue }}
                    {{ transItem?.EmployeeTransactionCommission?.IsCommissionTypeCount == false ?
                    (sharedService.Lang == 'ar' ? (sharedService.AccountCurrency?.NameAr | translate) :
                    (sharedService.AccountCurrency?.NameEn | translate)) : ('Servicess' | translate) }}:


                  </p>

                </div>
                <div style="display: flex; justify-content: space-between">
                  <p style="padding: 0px; margin: 0px; font-size: 12px">
                    {{ "TotalInvestigator" | translate }} :

                    {{ transItem?.EmployeeTransactionCommission?.IsCommissionTypeCount == false ?
                    ( transItem?.EmployeeTransactionCommission?.TotalAchievedServicePrice) :
                    ( transItem?.EmployeeTransactionCommission?.TotalInvoicesCount)}}
                  </p>
                  <p style="padding: 0px; margin: 0px; font-size: 12px" *ngIf="
                      transItem?.EmployeeTransactionCommission?.IsTargetAccomplished == true">
                    {{ "TargetAchieved" | translate }}
                  </p>
                  <p style="padding: 0px; margin: 0px; font-size: 12px" *ngIf="
                      transItem?.EmployeeTransactionCommission?.IsTargetAccomplished == false">
                    لم يتم تحقيق التارجت حتى الأن
                  </p>
                </div>
                <div style="display: flex; justify-content: space-between">
                  <p style="padding: 0px; margin: 0px; font-size: 12px">
                    الايام المتبقية لتحقيق التارجت :
                    {{ transItem?.EmployeeTransactionCommission?.RemainingTargetDays }}
                  </p>
                </div>

              </td>

            </tr>

            <tr *ngIf="AccountSetup?.AllowTracingCommissionInCashSale == true
            && transItem?.EmployeeTransactionCommission == null
            && transItem.ItemId === transItem.ItemId">

              <td colspan="6">
                <div style="display: flex; justify-content: space-between">
                  <p style="padding: 0px; margin: 0px; font-size: 12px">
                    {{ "NoCommissionCalculated" | translate }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p style="
          text-align: start;
          font-size: 14px;
          font-weight: 500;
          color: #000;
        ">
        {{ item.Comment }}
      </p>

      <div style="display: flex; align-items: center; justify-content: center;">
        <span *ngIf="AccountSetup?.AllowUseClientsQueueSystem &&
          AccountSetup?.AllowShowClientsQueueNumberInPrintEmployees &&
          AccountSetup?.ClientsQueueSystemType == 1 &&
          item.ClientNumberInQueue && item.ClientNumberInQueue > 0" style="margin-right:30px;">

          <!-- <div style="text-align: center;">
            <span style="display: block; font-size: 25px; font-weight: 700;">{{ "ClientNumberInQueue" |
              translate
              }}</span>
          </div> -->
          <p style="text-align: center; font-weight: 700; color: #000;
              font-family: initial;font-size: 30px; font-weight: 700;margin: 15; background-color: #373333  !important;
              color: white;padding: 5px; border-radius: 5px; -webkit-print-color-adjust: exact !important;">
            <span>{{ item?.ClientNumberInQueue }}</span>
          </p>
        </span>
      </div>

      <div style="display: flex; align-items: center; justify-content: center;">
        <span *ngIf="sharedService?.CurrentBranch?.AllowUseClientsQueueSystem &&
        sharedService?.CurrentBranch?.AllowShowClientsQueueNumberInPrintEmployees &&
        sharedService?.CurrentBranch?.ClientsQueueSystemType == 2" style="margin-right:30px;">

          <!-- <div style="text-align: center;">
            <span style="display: block; font-size: 25px; font-weight: 700;">{{ "ClientNumberInQueue" |
              translate
              }}</span>
          </div> -->
          <p *ngIf="getCategoryNameName(transItem)" style="text-align: center; font-weight: 700; color: #000;
                        font-family: initial; font-size: 20px; background-color: #373333  !important;
                        color: white; border-radius: 5px; -webkit-print-color-adjust: exact !important;">
            <span>{{ getCategoryNameName(transItem) }}</span>
          </p>

          <p style="text-align: center; font-weight: 700; color: #000;
              font-family: initial;font-size: 30px; background-color: #373333  !important;
              color: white; border-radius: 5px; -webkit-print-color-adjust: exact !important;">
            <span>{{ transItem.ClientNumberInQueue }}</span>
          </p>
        </span>
      </div>


      <span *ngIf="sharedService.CurrentBranch.AllowChangeBillItemsEmployeesByQRCode">

        <div class="row">
          <div class="col-lg-12 " style="text-align: center;">
            <h3 style=" color:#000; font-weight:900;">
              {{ ('ScanToChangeItemEmployeeToYourself'|translate )}}
            </h3>
          </div>
          <div class="col-lg-12 " style="text-align: center;">
            <h4 style=" color:#000; font-weight:900;">
              {{ 'ItemName'|translate }} :

              {{(transItem.Note == "PackageService" ? (('PackageService'|translate) + " - ") : "") +
              (transItem.service
              ? printLang == "ar"
              ? transItem.service.NameAr
              : transItem.service.NameEn
              : transItem.Service
              ? printLang == "ar"
              ? transItem.Service.NameAr
              : transItem.Service.NameEn
              : transItem.product
              ? printLang == "ar"
              ? transItem.product.NameAr
              : transItem.product.NameEn
              : transItem.Package
              ? printLang == "ar"
              ? transItem.Package.NameAr
              : transItem.Package.NameEn
              : transItem.OffersSetting
              ? printLang == "ar"
              ? transItem.OffersSetting.NameAr
              : transItem.OffersSetting.NameEn
              : "")
              }}
            </h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12 " style="text-align: center;">

            <div style="display: flex; align-items: center; justify-content: center;">
              <div style="text-align: center;">
                <ngx-qrcode [width]="250" [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="(transItem.Note == 'PackageService' ?
                   BillInfoForPackageUrl : BillInfoUrl) + transItem.Id" alt="Demo QR Code"
                  cssClass="bshadow"></ngx-qrcode>
              </div>
            </div>

          </div>
        </div>
      </span>

    </div>
  </div>
</div>
